import type * as lazyIndex from './lazyIndex';
import { popoutMailReadingPane } from 'owa-popout';
import {
    LazyModule,
    registerLazyOrchestrator,
    createLazyComponent,
    LazyAction,
    type LazyComponent,
} from 'owa-bundling';
import type { ProjectionReadingPaneProps } from './components/ProjectionReadingPane';

export const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "PopoutMailReadingPane"*/ './lazyIndex'),
    { name: 'PopoutMailReadingPane' }
);

// Register lazy orchestrators
registerLazyOrchestrator(
    popoutMailReadingPane,
    lazyModule,
    m => m.popoutMailReadingPaneOrchestrator
);

// Lazy components
export const ProjectionReadingPane: LazyComponent<ProjectionReadingPaneProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.ProjectionReadingPane);
export const lazyPopoutMailReadingPaneUtil: LazyAction<
    typeof lazyIndex.popoutMailReadingPaneUtil,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.popoutMailReadingPaneUtil);
